import { GetterTree } from 'vuex';

import { StateType } from './state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const moduleGetters: GetterTree<StateType, any> = {
  joinIdToJid(state, getters, rootState, rootGetters) {
    return (id: string, isGroup: boolean) => {
      const domain = rootGetters['xmppClient/currentDomain'];
      return `${id}@${isGroup ? 'group.' : ''}${domain}`;
    };
  },
};

export default moduleGetters;